
export function playPauseVideo() {

  const button = document.getElementById("playPauseButton");
  const video = document.querySelector(".block--homepage-banner video");

  if (button && video) {
    button.addEventListener("click", function () {
      if (video.paused) {
        video.play();
        button.classList.add("play");
        button.classList.remove("pause");
        button.setAttribute("aria-label", "Pause video");
        button.setAttribute("aria-pressed", "true");
      } else {
        video.pause();
        button.classList.add("pause");
        button.classList.remove("play");
        button.setAttribute("aria-label", "Play video");
        button.setAttribute("aria-pressed", "false");
      }
    });
  }
}
